import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useQuery } from '@apollo/client';

import Loader from '../../../components/Common/Loader/Loader';
import UserList from '../../../components/Users/UsersList/UserList';

import { getAllUsersQuery } from '../../../lib/graphql';
import messages from '../../../locale/messages';


const Users = ({ intl }) => {
  const { formatMessage } = intl;

  // --- Pagination State ---
  const [currentPage, setCurrentPage] = useState(1);
  const [searchList, setSearchList] = useState('');

  const { data, loading, error, refetch } = useQuery(getAllUsersQuery, {
    variables: {
      currentPage,
      searchList,
      userType: 1
    },
    fetchPolicy: 'network-only',
    ssr: false
  });

  // Optional: reset to page 1 on search change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchList]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const userDetails = {
    ...data,
    loading,
    error,
    refetch,
    currentPage
  };

  return (
    <Loader type="page" show={loading}>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.usersMenu)}</h1>
      {!loading && (
        <UserList
          userDetails={userDetails}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          setSearchList={setSearchList} // optional: pass if search input exists
        />
      )}
    </Loader>
  );
};

export default injectIntl(Users);
